import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Table,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import { format, addSeconds } from "date-fns";
import MeasurementService from "../services/measurementService";

const BeitsTijden = (props) => {
  const [metingen, setMetingen] = useState([]);
  const [meting, setMeting] = useState();
  const [proces, setProces] = useState("Anodiseren");
  const [dikte, setDikte] = useState("10-15");

  const diktes = ["10-15", "16-20", "21-25"];

  const hoeveelheden = [
    { name: "1/4", factor: 0.25 },
    { name: "1/3", factor: 0.333333 },
    { name: "1/2", factor: 0.5 },
    { name: "2/3", factor: 0.666666 },
    { name: "3/4", factor: 0.75 },
    { name: "BT", factor: 1 },
    { name: "1 1/4", factor: 1.25 },
    { name: "1 1/3", factor: 1.333333 },
    { name: "1 1/2", factor: 1.5 },
    { name: "1 2/3", factor: 1.666666 },
    { name: "1 3/4", factor: 1.75 },
    { name: "2", factor: 2 },
  ];

  const hoeveelhedenHA = [10, 15, 20, 25, 30];

  useEffect(() => {
    loadMeasurements();
  }, []);

  useEffect(() => {
    if (metingen.length) {
      setMeting(metingen[0]);
    }
  }, [metingen]);

  async function loadMeasurements() {
    setMetingen(await MeasurementService.getLast10Measurements());
  }

  function formatMeting(m) {
    if (!m) return "";
    return (
      format(m.MeasurementTimestamp, "d LLL HH:mm") +
      ", " +
      m.micronsPerMinute +
      " micron/min"
    );
  }

  function calculateTime(factor) {
    if (!meting) return "";
    const target = parseInt(dikte.substr(0, 2)) + 2; // +2 for avg. Ie. '10-14' = 12
    const seconds = Math.round(
      ((target * factor) / (meting.MicronsPerMinute / 2)) * 60 * (1 / 3)
    );
    var helperDate = addSeconds(new Date(0), seconds);
    return format(helperDate, "mm:ss");
  }

  function calculateTimeHA(target) {
    // (target * factor) / micronPerMinute = duration
    if (!meting) return "";
    const seconds = Math.round((target / meting.MicronsPerMinute) * 60);
    var helperDate = addSeconds(new Date(0), seconds);
    return format(helperDate, "mm:ss");
  }

  if (!metingen.length && !meting) return null;

  return (
    <div className="my-5">
      <h3 className="mb-4">Beitsteiden</h3>
      <Form.Group as={Row}>
        <Form.Label as={Col} className="mt-1" xs={3}>
          Meting:
        </Form.Label>
        <Col>
          <DropdownButton
            id="dropdown-basic-button"
            title={meting ? formatMeting(meting) : "Geen meet data"}
          >
            {metingen.map((m) => (
              <Dropdown.Item key={m.RowKey} onClick={() => setMeting(m)}>
                {formatMeting(m)}
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label as={Col} className="mt-1" xs={3}>
          Process:
        </Form.Label>
        <Col>
          <DropdownButton
            id="dropdown-basic-button"
            title={proces ? proces : "Geen meet data"}
          >
            <Dropdown.Item
              key="Anodiseren"
              onClick={() => setProces("Anodiseren")}
            >
              Anodiseren
            </Dropdown.Item>
            <Dropdown.Item
              key="Hard anodiseren"
              onClick={() => setProces("Hard anodiseren")}
            >
              Hard anodiseren
            </Dropdown.Item>
          </DropdownButton>
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label as={Col} className="mt-1" xs={3}>
          Dikte:
        </Form.Label>
        <Col>
          <DropdownButton
            id="dropdown-basic-button"
            title={proces !== "Anodiseren" ? "n.v.t." : dikte}
            disabled={proces !== "Anodiseren"}
          >
            {diktes.map((d) => (
              <Dropdown.Item key={d} onClick={() => setDikte(d)}>
                {d}
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </Col>
      </Form.Group>
      <Table style={{ width: 240 }} className="my-5" striped>
        <thead>
          <tr>
            <th>Beitsen</th>
            <th>Duur</th>
          </tr>
        </thead>

        {proces === "Anodiseren" ? (
          <tbody>
            {hoeveelheden.map((h) => (
              <tr key={h.name}>
                <td>{h.name}</td>
                <td
                  style={
                    h.name === "BT"
                      ? { color: "red", background: "yellow" }
                      : {}
                  }
                >
                  {calculateTime(h.factor)}
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            {hoeveelhedenHA.map((ha) => (
              <tr key={ha}>
                <td>{ha}</td>
                <td>{calculateTimeHA(ha)}</td>
              </tr>
            ))}
          </tbody>
        )}
      </Table>
    </div>
  );
};

export default BeitsTijden;
